/* Vitrine inteligente — Recomendações do Shopify (related / complementary).
   Busca via Product Recommendations API (machine learning da loja) e injeta os
   cards. Se não houver recomendações, esconde a seção. O visual/comportamento é o
   mesmo das outras vitrines (custom elements jm-vitrine.js já carregados na página). */
(function () {
  document.querySelectorAll('[data-jm-reco]').forEach(function (box) {
    if (box.dataset.jmRecoDone) return;
    box.dataset.jmRecoDone = '1';

    var pid = box.dataset.productId;
    var sid = box.dataset.sectionId;
    var intent = box.dataset.intent || 'related';
    var limit = box.dataset.limit || '8';
    if (!pid || !sid) return;

    var url = '/recommendations/products'
      + '?section_id=' + encodeURIComponent(sid)
      + '&product_id=' + encodeURIComponent(pid)
      + '&intent=' + encodeURIComponent(intent)
      + '&limit=' + encodeURIComponent(limit);

    fetch(url)
      .then(function (r) { return r.text(); })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var fresh = doc.querySelector('[data-jm-reco]');
        var hasCards = fresh && fresh.querySelector('jm-vitrine-card');
        if (hasCards) {
          box.innerHTML = fresh.innerHTML;
        } else if (!box.querySelector('jm-vitrine-card')) {
          // sem recomendações do ML e sem fallback SSR: esconde a seção inteira
          // (se o fallback por coleção já rendeu cards, eles ficam no lugar)
          var section = box.closest('.shopify-section') || box.parentElement;
          if (section) section.style.display = 'none';
        }
      })
      .catch(function () {});
  });
})();
